import registry from './copy-registry.json';
import type { GmailStatusState } from './hooks/use-gmail-status.types';

export type GmailBannerErrorCode =
  | 'GMAIL_TOKEN_EXPIRED'
  | 'GMAIL_TOKEN_MISSING'
  | 'GMAIL_SERVICE_UNAVAILABLE'
  | 'OAUTH_ACCOUNT_MISMATCH';

export type GmailBannerCopyKeys = {
  title: string;
  body: string;
  bodyMobile: string;
  cta: string;
  pill: string;
  dismiss: string;
};

type GmailBannerSection = {
  errorCodeToBannerState?: Partial<Record<GmailBannerErrorCode, GmailStatusState>>
  errorCodeToCopyKeys?: Partial<Record<GmailBannerErrorCode, GmailBannerCopyKeys>>
};

const section = (registry as Record<string, unknown>)['/gmail-status-banner'] as GmailBannerSection | undefined;

export const errorCodeToBannerState = section?.errorCodeToBannerState ?? {};
export const errorCodeToCopyKeys = section?.errorCodeToCopyKeys ?? {};

export function defaultErrorCodeForState(state: GmailStatusState): GmailBannerErrorCode | null {
  if (state === 'reconnect_required') return 'GMAIL_TOKEN_EXPIRED';
  if (state === 'service_unavailable') return 'GMAIL_SERVICE_UNAVAILABLE';
  return null;
}

export function getBannerStateForErrorCode(code?: string | null): GmailStatusState | null {
  if (!code) return null;
  return errorCodeToBannerState[code as GmailBannerErrorCode] ?? null;
}

export function getCopyKeysForBannerState(
  state: GmailStatusState,
  code?: string | null,
): GmailBannerCopyKeys | null {
  const mappedCode = (code && errorCodeToCopyKeys[code as GmailBannerErrorCode])
    ? code as GmailBannerErrorCode
    : defaultErrorCodeForState(state);

  if (!mappedCode) return null;
  return errorCodeToCopyKeys[mappedCode] ?? null;
}